import InfoPages from "../index";
import PageTitle from "../../../ui/PageTitle";
import MESSAGES from "../../../constants/messages";

const PrivacyAndPolicy = () => {
  return (<InfoPages>
    <PageTitle title={MESSAGES.PRIVACY_POLICY}/>

    <p><strong>Effective Date:</strong> May 14, 2026</p>

    <p>
      Welcome to <strong>ucr-registration.org</strong> (“Website”), operated by
      <strong>United Carrier Route Compliance</strong> (“Company,” “we,” “our,” or “us”).
      This Privacy Policy explains how we collect, use, disclose, and safeguard your information
      when you use our website and services related to transportation compliance filings,
      registrations, and related support services.
    </p>

    <h2>1. Important Disclosure</h2>
    <p>
      <strong>
        United Carrier Route Compliance is a private third-party filing and compliance assistance service
        provider.
      </strong>
      We are <strong>not affiliated with</strong>, endorsed by, or acting on behalf of the
      Federal Motor Carrier Safety Administration (FMCSA), Unified Carrier Registration (UCR),
      Department of Transportation (DOT), Oregon Department of Transportation (ODOT), or any other government agency.
    </p>

    <p>
      By using our services, you acknowledge that we are an independent third-party service provider
      assisting customers with transportation-related filings and compliance services.
    </p>

    <h2>2. Information We Collect</h2>
    <ul style={{marginLeft: "40px"}}>
      <li>Full name</li>
      <li>Business/company name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>Mailing address</li>
      <li>USDOT Number</li>
      <li>MC Number</li>
      <li>EIN / Tax-related information, when applicable</li>
      <li>Vehicle and carrier information</li>
      <li>Compliance-related filing information</li>
      <li>Payment-related information necessary to process services</li>
    </ul>

    <p>We collect only the information reasonably necessary to provide the services requested.</p>

    <h2>3. How We Use Information</h2>
    <ul style={{marginLeft: "40px"}}>
      <li>Process registrations, permits, and compliance filings</li>
      <li>Assist with transportation-related services requested by customers</li>
      <li>Verify customer submissions and prevent fraud</li>
      <li>Communicate regarding filings, status updates, or customer support inquiries</li>
      <li>Improve website functionality and customer experience</li>
      <li>Comply with legal, regulatory, and payment processing obligations</li>
    </ul>

    <h2>4. Third-Party Filing Authorization</h2>
    <p>
      By submitting information through our website and proceeding with a service request, you acknowledge and agree
      that:
    </p>
    <ul style={{marginLeft: "40px"}}>
      <li>You are voluntarily engaging United Carrier Route Compliance as a third-party filing and compliance assistance
        provider;
      </li>
      <li>You authorize us to assist with filings, registrations, permit applications, and compliance-related
        submissions on your behalf using the information you provide;
      </li>
      <li>You confirm that the information submitted is accurate and authorized for use.</li>
    </ul>

    <p>Customers remain responsible for ensuring the accuracy of all submitted information.</p>

    <h2>5. Payment Information</h2>
    <p>
      Payments are processed securely through approved third-party payment processors.
      We do not store complete payment card information on our servers.
    </p>

    <p>
      Payment information is handled through secure, industry-standard payment systems that use
      encryption and fraud prevention measures.
    </p>

    <p>
      Charges may appear on your bank or credit card statement as
      <strong>“United Carrier Route Compliance”</strong> or a similar billing descriptor.
    </p>

    <h2>6. Information Sharing</h2>
    <p>We do not sell customer information.</p>

    <p>We may share information only when reasonably necessary to:</p>
    <ul style={{marginLeft: "40px"}}>
      <li>Complete requested filings or registrations</li>
      <li>Work with government agencies or filing systems</li>
      <li>Process payments through authorized payment providers</li>
      <li>Work with vendors or service providers supporting our operations</li>
      <li>Comply with legal obligations, investigations, subpoenas, or law enforcement requests</li>
    </ul>

    <h2>7. Data Security</h2>
    <p>
      We take commercially reasonable measures to protect customer information.
      Our website uses SSL encryption and other industry-standard safeguards designed to help protect
      information submitted through the website.
    </p>

    <p>Although we take reasonable precautions, no system can guarantee absolute security.</p>

    <h2>8. Cookies & Website Analytics</h2>
    <p>Our website may use cookies and analytics technologies to:</p>
    <ul style={{marginLeft: "40px"}}>
      <li>Improve website performance</li>
      <li>Remember customer preferences</li>
      <li>Analyze traffic and improve user experience</li>
    </ul>

    <h2>9. Customer Responsibility</h2>
    <p>
      Customers are responsible for ensuring that all information submitted through the website
      is complete, accurate, and up to date.
    </p>

    <p>
      United Carrier Route Compliance is not responsible for delays, rejections, or penalties
      resulting from incomplete or incorrect information submitted by customers.
    </p>

    <h2>10. Policy Updates</h2>
    <p>
      We reserve the right to revise or update this Privacy Policy at any time without prior notice.
      Continued use of the website constitutes acceptance of any updates.
    </p>

    <h2>11. Contact Information</h2>
    <p>
      <strong>United Carrier Route Compliance</strong><br/>
      6817 Foothill Blvd<br/>
      Tujunga, CA 91042<br/>
      Website: <a href="https://ucr-registration.org">https://ucr-registration.org</a><br/>
      Email: <a href="mailto:support@ucr-registration.org">support@ucr-registration.org</a>
    </p>
  </InfoPages>);
};

export default PrivacyAndPolicy;
